module.exports = __webpack_public_path__ + "img/reports-en.e400da8.png";